// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-6552b748","scoped":true,"hasInlineConfig":false}!./src/components/nudge-console/create-campaign/chat-panel/ChatPanel.css
// module id = e55B
// module chunks = 1